export default __webpack_public_path__ + "static/media/redbook-white.9542e216.svg";